import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    tab: 0,
};

const helperSlice = createSlice({
    name: 'helper',
    initialState,
    reducers: {
        setTab: (state, action) => {
            state.tab = action.payload;
        }
    },
});

export const { setTab } = helperSlice.actions;
export default helperSlice.reducer;
